import React, { useEffect, useState } from 'react'

// react redux
import { connect } from 'react-redux'

// react bootstrap
import { Container, Spinner } from 'react-bootstrap'

// styles
import './styles/google-shopping-styles.scss'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// toast
import { toast } from 'react-toastify'

// API
import { getGoogleShoppingSettings, setGoogleShoppingCategories } from 'utlis/Apis/GoogleShopping_API';

// imports
import ShoppingFeed from './includes/ShoppingFeed'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'


function GoogleShopping(props) {

    const { authState, setGlobalLoading } = props

    // states
    const [submitButtonDisable, setSubmitButtonDisable] = useState(false)
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false)

    const [categoriesDetails, setCategoriesDetails] = useState(null)
    const [categoryValue, setCategoryValue] = useState("")

    // checking if the link is already added
    useEffect(() => {
        // loading
        setGlobalLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getGoogleShoppingSettings(headers).then(res => {
            // loading
            setGlobalLoading(false)

            const resData = res.data

            // if request is success
            if (resData?.success) {
                const dataToUse = resData.data

                setCategoriesDetails(dataToUse) // setting categories details
            }

            // if request is error
            if (resData?.error) {
                // dismissing all the toasts
                toast.dismiss();

                // showing the toast
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getGoogleShoppingSettings `, err.message)

            // dismissing all the toasts
            toast.dismiss();

            // showing the toast
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // loading
                    setGlobalLoading(false)
                }
            })
        })
    }, [authState, setGlobalLoading])

    // when submit button gets clicked
    const handleSubmitBtnClick = ev => {
        ev.preventDefault()

        if (categoryValue) {
            // loading
            setSubmitButtonDisable(true)
            setSubmitButtonLoading(true)

            const requiredData = {
                category: categoryValue,
                breadcrumb: "",
                product_type: "New"
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // setting google categories data
            setGoogleShoppingCategories(headers, requiredData).then(res => {
                // loading
                setSubmitButtonDisable(false)
                setSubmitButtonLoading(false)

                const resData = res.data

                // if request is success
                if (resData?.success) {
                    const dataToUse = resData.data

                    setCategoriesDetails(dataToUse) // setting categories details

                    // dismissing all the toasts
                    toast.dismiss();

                    // showing the toast
                    toast.success("Details added successfully", {
                        autoClose: 2500
                    })
                }

                // if request is error
                if (resData?.error) {
                    // dismissing all the toasts
                    toast.dismiss();

                    // showing the toast
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} setGoogleShoppingCategories `, err.message)

                // dismissing all the toasts
                toast.dismiss();

                // showing the toast
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setSubmitButtonDisable(false)
                        setSubmitButtonLoading(false)
                    }
                })
            })
        }

    }

    // get selected category
    const getSelectedCategory = data => {
        if (data) {
            setCategoryValue(data)
        }
    }

    return (
        <section id="app-google-shopping" className="st-def-mar-TB">
            <Container fluid className="st-container">
                {
                    /* back button */
                    categoriesDetails === null ? (
                        <div className="page-save-button-block d-flex align-items-center mb-1">
                            {/* SAVE BTN */}
                            <button
                                className={`st-btn st-btn-primary ms-auto ${((!categoryValue?.length) || submitButtonDisable) ? "disabled" : ""}`}
                                disabled={(!categoryValue?.length) || submitButtonDisable}
                                onClick={ev => handleSubmitBtnClick(ev)}>
                                {
                                    submitButtonLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <span>Save</span>
                                    )
                                }
                            </button>
                        </div>
                    ) : null
                }

                <div className="app-google-shopping">
                    {/* header */}
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Sell on Google Shopping</p>
                        {/* <p className="app-desc">
                            Keep yourself and customers informed with automated notifications. Send order updates, remind customers about your products, and keep up with what’s happening in your store.
                        </p> */}
                    </div>

                    <div className="app-content-container">

                        {/* fixed page view */}
                        <div className="fixed-left-page-view-container google-shopping-container">
                            <div className="flpvc-inner d-flex flex-wrap">
                                {/* left sec */}
                                <div className="flpvc-lt-sec">
                                    <div className="inner">
                                        {/* heading */}
                                        <div className="app-header-wrapper heading-sm mb-3">
                                            <p className="app-heading text-capitalize mb-2">Google Shopping product feed</p>
                                            <p className="app-desc">
                                                Generate your product feed and manage your campaigns manually.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* right sec */}
                                <div className="flpvc-rt-sec media-body ps-3">
                                    <div className="inner">
                                        {/* Senders Info */}
                                        <ShoppingFeed
                                            defaultValue={categoryValue}

                                            getSelectedCategory={getSelectedCategory}

                                            categoriesDetails={categoriesDetails}
                                        />
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>


                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(GoogleShopping)